"use strict";

export function initInScope ($scope) {
    $scope.find('.js-register-val').on('click',function (e) {
        e.preventDefault();

        let registerUrl = $(this).attr('data-register');
        $scope.find('.js-register-link').attr('href',registerUrl);
    });
}